import styled from 'styled-components';
import * as antd from 'antd';

export const SelectContracts = styled((props) => <antd.Select {...props} />)`
 width: 280px;
 margin-right: 20px;
`;
